module.exports = __webpack_public_path__ + "assets/ea9e3b8787e815462a3ca8ceb4522833.mp3";